import { getFavIdxByHostID } from '@/hooks/useFavorite';
import { WorkerActionData } from '@/hooks/useSecWorker';
import { getEmptyBetInfo, getNewBetRoom } from '@/models/games/BetRoom';
import { GameType } from '@/models/games/enums/GameType';
import { animationSliceActions } from '@/modules/animation/slice';
import { betRoomSliceActions } from '@/modules/bet/room/slice';
import { TableBet, tableBetSliceActions } from '@/modules/betTable/slice';
import { goodRoadsSliceActions } from '@/modules/goodRoad/slice';
import { SupportedGameLiveData } from '@/modules/hostLive/models';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { getMainPlayerState } from '@/modules/main/selector';
import { userSliceActions } from '@/modules/main/slice/user';
import store from '@/store/store';
import { isBitActive } from '@/utils/bitwiseUtil';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { GameConfigHostsType } from '../../../hooks/useConfig';
import { HostTable } from '../../../modules/host/models';
import { hostsSliceActions } from '../../../modules/host/slice';
import {
    InGamePopupState,
    inGamePopupSliceActions,
} from '../../../modules/popup/inGameSlice';
import { resultProgressSliceActions } from '../../../modules/progress/slice/result';
import { StateMsgType } from '../../Popup';
import { Progress } from '../../games/Progress';
import { CMDSpHostList, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

enum HostSetting {
    Gift_Enable,
    Chat_Enable,
}

export class CMDSpHostListHandler extends AbstractHandler {
    _command: ICommand;
    _gameConfigHosts: Array<GameConfigHostsType>;
    _gameConfigHostsKey: number[];
    _productionTestPermission: boolean;
    _dafaBetPermission: boolean;
    _hostList: Array<HostTable>;
    _registWorkerAction: (item: WorkerActionData) => void;
    constructor(
        command: ICommand,
        gameConfigHosts: Array<GameConfigHostsType>,
        productionTestPermission: boolean,
        dafaBetPermission: boolean,
        registWorkerAction: (item: WorkerActionData) => void
    ) {
        super();
        this._command = command;
        this._gameConfigHosts = gameConfigHosts;
        this._gameConfigHostsKey = this._gameConfigHosts.map(v => v.hostId);
        this._productionTestPermission = productionTestPermission;
        this._dafaBetPermission = dafaBetPermission;
        this._registWorkerAction = registWorkerAction;
    }
    hostList(): Array<HostTable> {
        let order = 0;
        const hostListCommand = this._command as CMDSpHostList;
        this._hostList = hostListCommand.Host.filter(h => {
            const hostId = h.HostID;
            //if (this._gameConfigHostsKey.includes(hostId)) return true;

            if (this._gameConfigHostsKey.includes(hostId)) {
                return true;
            }

            return false;
        })
            .sort((a, b) => {
                if (!this._gameConfigHostsKey) return 0;
                return (
                    this._gameConfigHostsKey.indexOf(a.HostID) -
                    this._gameConfigHostsKey.indexOf(b.HostID)
                );
            })
            .map(h => {
                const hostId = h.HostID;
                const gameConfig =
                    this._gameConfigHosts[
                        this._gameConfigHostsKey.indexOf(hostId)
                    ];
                const group = gameConfig.group;
                let hallStateName = 'other';
                if (group.length >= 1) {
                    hallStateName = group[0] + 'Hall';
                }
                const hall = gameConfig.hall;
                order++;
                let orderBy = order;
                // if (hall) {
                //     orderBy =
                //         (this._gameConfigHallOrder.indexOf(Number(hall)) + 1) *
                //             100 +
                //         orderBy;
                // } else {
                //     orderBy = orderBy + 1000;
                // }
                if (hostId < 300 || hostId >= 400) {
                    const favIdx = getFavIdxByHostID(hostId);
                    if (favIdx < 0) {
                        console.warn(`${hostId} favidx not found`);
                    }
                }
                // console.log('????', hostId, orderBy);
                return {
                    HostId: hostId,
                    Setting: h.Setting,
                    //GameType: h.GameType,
                    //game_config
                    HallId: hall,
                    GameType: gameConfig.type,
                    Group: group,
                    HallStateName: hallStateName,
                    Video: gameConfig.video,
                    Audio: gameConfig.audio,
                    Hls: gameConfig.hls,
                    Nano: gameConfig.nano,
                    HostName: gameConfig.hostName,
                    DelayDraw: gameConfig.delayDraw,
                    DelayResult: gameConfig.delayResult,
                    DelayZoom:
                        gameConfig.delayZoom !== undefined
                            ? gameConfig.delayZoom
                            : 5000,
                    enabled: gameConfig.enabled,
                    TableLimit: gameConfig.tableLimit,
                    Time: gameConfig.time,
                    Sai:
                        gameConfig.sai &&
                        window.location.host.indexOf('.sai.') >= 0
                            ? new Date(
                                  `${gameConfig.sai} 12:00:00 GMT+0000`
                              ).getTime()
                            : undefined, //e.g.2024-08-05
                    ShuffleDelay: gameConfig.shuffleDelay,
                    tableTheme: gameConfig.tableTheme,
                    IsTest: gameConfig.hostId >= 300 && gameConfig.hostId < 400,
                    OrderBy: orderBy,
                    IsRest: true, //set default true, 有CMD冇返到IsRest，所以set default = true;
                    IsInited: false,
                    ChatEnabled: isBitActive(
                        h.Setting,
                        HostSetting.Chat_Enable
                    ),
                    GiftEnabled: isBitActive(
                        h.Setting,
                        HostSetting.Gift_Enable
                    ),
                } as HostTable;
            });
        // DEV ONLY
        // this._hostList.push({
        //     GameID: 0,
        //     HostId: 999,
        //     GameType: 262144,
        //     AllowSideBet: false,
        //     Rest: 0,
        //     Seat: 0,
        //     Setting: 0,
        //     OrderBy: 0,
        //     HallId: 0,
        //     Group: '',
        //     Video: '',
        //     Audio: false,
        //     Hls: '',
        //     Nano: '',
        //     HostName: 'TEST CT',
        //     DelayDraw: 0,
        //     DelayResult: 0,
        //     DelayZoom: 0,
        //     enabled: false,
        //     TableLimit: 0,
        //     Time: 0,
        //     WinAmount: 0,
        //     OldResult: [],
        //     IsRest: false,
        //     IsInited: false,
        //     IsInternalTest: false,
        // });
        return this._hostList;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const hosts = this._hostList ? this._hostList : this.hostList();
        const popup = hosts.map(
            h =>
                ({
                    isOpen: false,
                    key: '',
                    gameType: h.GameType,
                    stateMsgType: StateMsgType.betInfo_Normal,
                    gameId: 0,
                    hostId: h.HostId,
                    dismiss: 2000,
                }) as InGamePopupState
        );
        const tableBet = hosts.map(
            h =>
                ({
                    HostId: h.HostId,
                    GameId: 0,
                    BetSeqId: 0,
                    PlayerBets: [],
                    PendingBets: [],
                    ConfirmedBets: [],
                    BetsSummary: [],
                    TableTotalBet: 0,
                    PendingTotalBet: 0,
                    isWaitingBet: false,
                    isBetConfirmed: false,
                    ReadySync: 0,
                }) as TableBet
        );
        const liveData = hosts.map(
            h =>
                ({
                    HostId: h.HostId,
                }) as SupportedGameLiveData
        );
        const goodRoads = hosts
            .filter(h => h.GameType === GameType.Baccarat)
            .map(h => ({
                HostId: h.HostId,
                isGoodRoad: false,
                isRest: true,
            }));
        const player = getMainPlayerState(state);
        for (const host of hosts) {
            // game special handling
            if (host.GameType === GameType.Blackjack) {
                const initBetRoom = getNewBetRoom(host.HostId);
                const initBetInfo = getEmptyBetInfo();
                initBetInfo.PlayerId = player.Id;
                initBetRoom.Info[0] = initBetInfo;
                dispatch(betRoomSliceActions.init(initBetRoom));
            } else if (host.GameType === GameType.CarnivalTreasure) {
                dispatch(animationSliceActions.add(host.HostId));
            }

            this._registWorkerAction({
                key: host.HostId.toString(),
                time: 10,
                callbackFunc: () => {
                    dispatch(
                        hostsSliceActions.gameInitTimeout({
                            hostId: host.HostId,
                        })
                    );
                },
            });
        }
        batch(() => {
            dispatch(inGamePopupSliceActions.setAll(popup));
            dispatch(hostsSliceActions.setAll(hosts));
            dispatch(hostLiveSliceActions.setAll(liveData));
            dispatch(tableBetSliceActions.setAll(tableBet));
            dispatch(goodRoadsSliceActions.updateAll(goodRoads));
            dispatch(
                resultProgressSliceActions.endLoad(Progress.SERVER_HOST_LIST)
            );
            dispatch(userSliceActions.hostListInited());
        });
    }
}
